<template>
    <component :is="getCompanyIntermediaryPage" />
</template>

<script>
    import CanaryWharfGroup from './intermediary/CanaryWharfGroup';

    export default {
        name: 'whitelabel-intermediary',

        props: {
            subdomain: {
                type: String,
                default: '',
            },
        },

        data() {
            return {
                intermediariesComponent: {
                    canarywharfgroup: CanaryWharfGroup,
                },
                routePath: {
                    canarywharfgroup: '/cwg-app',
                },
            };
        },

        computed: {
            /**
             * Get and render the company intermediary page.
             *
             * @returns {String}
             */
            getCompanyIntermediaryPage() {
                return this.intermediariesComponent[this.subdomain];
            },

            /**
             * Get the correct pathname for intermediary page.
             *
             * @returns {String}
             */
            getCorrectPath() {
                return this.routePath[this.subdomain] || '/';
            },
        },

        mounted() {
            this.redirectToCorrectPath();
        },

        methods: {
            /**
             * Redirect to respective pathname.
             */
            redirectToCorrectPath() {
                if (this.getCorrectPath !== location.pathname) {
                    location.assign(this.getCorrectPath);
                }
            },
        },
    };
</script>
